<div *ngIf="!getSessionExpired">
  <div class="card-body center" *ngIf="originalTransactions.length != 0; else noData">
    <div class="form-group d-flex flex-column flex-md-row justify-content-between">
      <div class="d-flex flex-wrap align-items-center">
        <label class="mb-0"><b>Филтрирайте по месец:</b></label>
        <select class="form-control mr-3 mr-md-0 mb-2 mb-md-0 ml-md-2" style="width: auto;" [(ngModel)]="selectedMonth"
          (change)="filterTransactions()">
          <option *ngFor="let month of months" [value]="month.prop">{{month.name}}</option>
        </select>
        <div class="secondFilter d-flex flex-grow-1" style="display: flex;">
          <label class="mb-md-0 ml-md-0 pt-2"><b>Или търсете по име:</b></label>
          <input type="text" class="form-control ml-3 ml-md-2 mb-2 mb-md-0" style="width: 300px;"
            placeholder="Търсене по име на трансакцията" [(ngModel)]="searchQuery" (input)="filterTransactions()">
        </div>
      </div>
      <button class="btn btn-primary export" (click)="exportToCSV()">Свалете вашия отчет</button>
    </div>

    <div class="table-responsive">
      <table class="table table-hover">
        <caption *ngIf="transactions.length !== 0" class="text-black">* Кликнете на реда, за да редактирате или изтриете
          запис.</caption>
        <thead>
          <tr>
            <th scope="col">Име на трансакцията</th>
            <th scope="col">Стойност</th>
            <th scope="col">Тип</th>
            <th scope="col">Дата</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngIf="transactions.length !== 0; else noResults">
            <tr *ngFor="let transaction of transactions" data-toggle="modal" data-target="#editTransactionModal"
              (click)="showTransactionModal(transaction)">
              <th>{{transaction.Name}}</th>
              <td>{{transaction.Amount}} лв.</td>
              <td>{{transaction.Type}}</td>
              <td>{{transaction.getFormattedDate()}}</td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
    <div *ngIf="notifications.length != 0">
      <div *ngFor="let notification of notifications">
        <div *ngIf="notification.isValid" class="alert alert-success alert-dismissible fade show" role="alert">
          {{notification.message}}
          <button (click)="removeNotification(notification.id)" class="close" type="button" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div *ngIf="!notification.isValid" class="alert alert-warning alert-dismissible fade show" role="alert">
          {{notification.message}}
          <button (click)="removeNotification(notification.id)" class="close" type="button" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #noResults>
  <div class="card-body center" style="position: relative; left: 30%;">
    <h4 class="mt-10" style="text-align: center;padding-top: 10%;padding-bottom: 10%;">Няма намерени
      резултати.</h4>
  </div>
</ng-template>

<ng-template #noData>
  <div class="card-body center">
    <h4 class="mt-10" style="text-align: center;padding-top: 10%;padding-bottom: 10%;">Все още няма данни, моля добавете
      трансакция от менюто <b>"Добавяне на нова трансакция"</b>!</h4>
  </div>
</ng-template>


<!-- Modal -->
<div class="modal fade" id="editTransactionModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle"
  aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content" *ngIf="editTransaction != null">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">{{editTransaction.Name}}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form [formGroup]="editForm">
          <div class="form-group">
            <label>Име на трансакцията:</label>
            <input class="form-control" type="text" name="name" formControlName="name" />
            <label>Стойност:</label>
            <input class="form-control" type="number" name="amount" formControlName="amount" />
            <label>Тип:</label>
            <input class="form-control" type="text" name="type" formControlName="type" />
            <label>Дата:</label>
            <input [value]="dateFilter()" class="form-control" type="date" name="date" formControlName="date" />
            Текуща дата: {{dateFilter()}}
          </div>
        </form>
      </div>
      <div class="modal-footer text-center justify-content-center">
        <button type="button" data-dismiss="modal" (click)="deleteTransaction()" class="btn btn-danger">Изтриване на
          трансакцията</button>
        <button type="button" data-dismiss="modal" (click)="updateTransaction()" class="btn btn-primary">Актуализиране
          на трансакцията</button>
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Затвори</button>
      </div>
    </div>
  </div>
</div>